<template>
  <div>
    <div class="welcome-container uk-flex uk-flex-center uk-flex-middle">
      <span class="welcome-text">{{$t('notebook.welcome')}}</span>
    </div>
    <div class="margins">
      <div class="info-container">
        <div class="icon-container uk-flex uk-flex-center">
          <img class="icon" :src="newLook">
        </div>
        <span class="info-text uk-flex uk-flex-center">{{$t('notebook.description')}}</span>
        <a class="link-text uk-text-bold learn-more-margin uk-flex uk-flex-center" @click="openLearnMore">{{$t('general.learnMore')}}</a>
      </div>
      <div class="quick-link-container">
        <span class="quick-link-text uk-flex uk-flex-center">{{$t('notebook.getStarted')}}</span>
        <div class="btn-container">
          <button class="btn-find-resource add-pointer" type="button" @click="openExchange">{{$t('notebook.findResource')}}</button>
        </div>
      </div>
      <div class="footer-container">
        <span class="footer-text uk-flex uk-flex-center">© {{smartCopyright}}</span>
      </div>
    </div>

  </div>
</template>

<script>
  import iconUtil from '../../utils/icon-util'
  import * as misc from '../../enums/misc'
  import * as url from '../../enums/static-urls'
  export default {
    name: 'notebook',
    data() {
      return {
        newLook: iconUtil.resolve(misc.NEW_LOOK),
        year: new Date().getFullYear(),
        copyright: this.$t('footer.copyright')
      }
    },
    metaInfo() {
      return {
        meta: [
          { name: 'robots',
            content: 'noindex'
          }
        ]
      }
    },
    methods: {
      openExchange() {
        window.open(url.SMART_EXCHANGE, '_blank')
      },
      openLearnMore() {
        window.open(url.SMEX_LEARN_MORE_VIDEO, '_blank')
      }
    },
    computed: {
      smartCopyright() {
        return this.year + ' ' + this.copyright
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../styles/colours.scss';
  @import '../../styles/breakpoints';

  .btn-container {
    margin-top: 32px;
    max-width: 368px;
    height: 50px;
    margin-left: auto;
    margin-right: auto;
  }

  .btn-find-resource {
    width: 100%;
    height: 100%;
    font-size: 18px;
    font-weight: bold;
    background-color: $light-blue;
    color: white;
    border-radius: 2px;
    &:hover {
      background-color: white;
      color: $light-blue;
      box-shadow: 3px 5px 8px 0 rgba(0, 0, 0, 0.24);
    }
  }

  .btn-share-resource {
    width: 100%;
    height: 100%;
    font-size: 18px;
    font-weight: bold;
    background-color: white;
    color: $slate;
    border-radius: 2px;
    border: solid 2px $slate;
    &:hover {
      box-shadow: 3px 5px 8px 0 rgba(0, 0, 0, 0.24);
      border: solid 2px white;
    }
  }

  .footer-container {
    margin-top: 153px;
    text-align: center;
  }

  .footer-text {
    font-size: 18px;
    color: $content-text;
  }

  .icon-container {
    margin-top: 33px;
  }

  .icon {
    width: 260px;
    height: 133px;
  }

  .info-container {
    font-size: 22px;
  }

  .info-text {
    text-align: center;
    margin-top: 35px;
    padding-left: 20px;
    padding-right: 20px;
    color: $content-text;
  }

  .learn-more-margin {
    margin-top: 32px;
  }

  .link-text {
    color: $light-blue;
  }

  .margins {
    margin-left: 65px;
    margin-right: 65px;
  }

  .quick-link-container {
    margin-top: 93px;
    text-align: center;
  }

  .quick-link-text {
    font-size: 22px;
    font-weight: bold;
    text-align: center;
  }

  .visit-link-style {
    margin-top: 26px;
    width: 100%;
    text-align: center;
  }

  .welcome-container {
    background-color: #80bd41;
    max-height: 123px;
    width: 100%;
  }

  .welcome-text {
    font-size: 32px;
    font-weight: bold;
    color: white;
    line-height: 100%;
    margin: 27px 92px 24px;
    text-align: center;
  }


  @media screen and (max-width: $breakpoint-mobile) {

    .footer-text {
      font-size: 16px;
    }

    .icon-container {
      margin-top: 10px;
    }

    .info-container {
      font-size: 16px;
    }

    .info-text {
      text-align: center;
      margin-top: 10px;
      padding-left: 5px;
      padding-right: 5px;
      color: $content-text;
    }

    .margins{
      margin-left: 55px;
      margin-right: 55px;
    }

    .quick-link-container {
      margin-top: 53px;
    }

    .welcome-text {
      margin: 17px 82px 14px;
      font-size: 22px;
    }

    .welcome-container {
      max-height: 250px;
    }
  }
</style>
